<template>
  <ul
    class="overview-item-group mb-11"
  >
    <li>
      <AtomsOverviewItemGroupHeading>
        {{ group.areaTitle }}
      </AtomsOverviewItemGroupHeading>
    </li>
    <li
      class="border-b-2 border-gray-400/50 last-of-type:border-0"
      v-for="item in sortedItems"
    >
      <MoleculesOverviewItem
        :item-raw-data="item"
        :tab-id="tabId"
        :plans="group.plans"
      />
    </li>
  </ul>
</template>

<script setup>
const props = defineProps({
  group: Object,
  tabId: String,
});

const sortedItems = computed(() => {
  //console.log("Original items:", props.group.items);
  const sorted = [...props.group.items].sort((a, b) => {
    // Check for existence of qmiHomeDetails and neighborhood before accessing title
    const titleA = a.qmiHomeDetails && a.qmiHomeDetails.neighborhood ? a.qmiHomeDetails.neighborhood.title : '';
    const titleB = b.qmiHomeDetails && b.qmiHomeDetails.neighborhood ? b.qmiHomeDetails.neighborhood.title : '';

    return titleA.localeCompare(titleB);
  });
  //console.log("Sorted items:", sorted); // Log the sorted items
  return sorted;
});

// console.log(props.group);
</script>
